export default __webpack_public_path__ + "static/media/4.1f717d62.jpeg";